import { useTranslations } from '@vocab/react';
import React from 'react';

import { Faqs } from 'src/app/views/components/Faqs';
import { PageSection } from 'src/app/views/sections/PageSection';

import translations from './.vocab';

export const FaqSection = () => {
  const { t } = useTranslations(translations);

  return (
    <PageSection heading={t('faq-heading')} subHeading={t('faq-subheading')}>
      <Faqs />
    </PageSection>
  );
};
